export default __webpack_public_path__ + "static/services-img-1-de330a49f84cdc33e1d1c880b3eb0178.png";